import { AsyncAction, CommanderThunkAction, WithEnterpriseId } from '@mews-commander/types';
import { RoutingRuleAddParameters, RoutingRuleAssignmentAddParameters } from '@mews-commander/data-access';
import { createFetchAction, mapId } from '@mews-commander/utils';
import { setRoutingRules } from '../ducks/routingRules';
import { setRoutingRuleAssignments } from '../ducks/routingRuleAssignments';
import prefix from '../prefix';
import { setProfiles } from '../ducks/profiles';

const ROUTING_FETCH = prefix('ROUTING_FETCH');

export const fetchRoutingRules =
    ({
        routingRuleIds,
        enterpriseId,
    }: {
        routingRuleIds: string[];
        enterpriseId: string;
    }): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.routingRules
            .getAll({
                routingRuleIds,
                enterpriseId,
                extent: {
                    routingRuleAssignments: true,
                    profiles: true,
                    productCategoryAssignments: false,
                    productAssignments: false,
                    rateAssignments: false,
                    accountingCategoryAssignments: false,
                },
            })
            .then(({ routingRules, routingRuleAssignments, profiles }) => {
                if (routingRules != null) {
                    dispatch(setRoutingRules(routingRules, enterpriseId));
                }

                if (routingRuleAssignments != null) {
                    dispatch(setRoutingRuleAssignments(routingRuleAssignments, enterpriseId));
                }

                if (profiles != null) {
                    dispatch(setProfiles(profiles));
                }
            });

        return dispatch(createFetchAction(ROUTING_FETCH, promise));
    };

export const addRoutingRules =
    ({
        routingRules,
        enterpriseId,
    }: {
        routingRules: RoutingRuleAddParameters[];
    } & WithEnterpriseId): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.routingRules
            .add({ routingRules, enterpriseId })
            .then(({ routingRules: rules }) => {
                if (rules != null) {
                    dispatch(setRoutingRules(rules, enterpriseId));
                }

                return { routingRuleIds: mapId(rules) };
            });

        return dispatch(createFetchAction(ROUTING_FETCH, promise));
    };

export const addRoutingRuleAssignments =
    ({
        routingRuleAssignments,
        enterpriseId,
    }: {
        routingRuleAssignments: RoutingRuleAssignmentAddParameters[];
    } & WithEnterpriseId): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.routingRuleAssignments
            .add({ routingRuleAssignments, enterpriseId })
            .then(({ routingRuleAssignments: assignments }) => {
                if (assignments != null) {
                    dispatch(setRoutingRuleAssignments(assignments, enterpriseId));
                }
            });

        return dispatch(createFetchAction(ROUTING_FETCH, promise));
    };
